<template>
    <div class="accessory-item">
        <div class="accessory-item-content">
            <div class="accessory-item-image">
                <img :src="productImage" alt="">
            </div>
            <div class="accessory-item-text">
                <h5 class="accessory-item-name">
                    {{ accessory.name }}
                </h5>
                <p v-if="variantInCart.colors_code" class="accessory-item-color">
                    {{ variantInCart.colors }}
                </p>
            </div>
        </div>
        <div v-if="type != 'specials'" class="accessory-item-actions">
            <div 
                v-if="accessory.variants[0].peripherals_types_id != CONSTANTS.PERIPHERALS.HEADSET && !accessory.variants[0].hasOwnProperty('bundles_types_id')" 
                class="accessory-item-multiselect"
            >
                <multiselect
                    v-model="qty"
                    :allow-empty="false"
                    :class="{ 'disable-element': isUpdating }"
                    :disabled="isUpdating"
                    :options="[1, 2, 3]"
                    :searchable="false"
                    :show-labels="false"
                    @input="updateAccessories(qty)"
                />
            </div>
            <div class="accessory-item-blank" v-else/>
            <div class="accessory-item-delete">
                <img
                    src="/images/icons/cart-icons/trash.svg"
                    title="Remove Accessory"
                    alt="Remove Accessory"
                    @click="removePart(variantInCart)"
                >
            </div>
            <p class="accessory-item-price">{{ variantInCart.price | formatMoney }}</p>
        </div>
        <div v-else class="accessory-item-actions included">
            <p class="accessory-item-price included__text">INCLUDED</p>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import CONSTANTS from "../../../../config/constants";
import accessoriesMixin from "../accessories-mixin";

export default {
    name: "AccessoryItem",
    mixins: [
        accessoriesMixin
    ],
    data() {
        return {
            CONSTANTS
        }
    },
    computed: {
        ...mapState({
            which: state => state.StarterPc.which
        })
    }
}
</script>

<style lang="scss" scoped>
@import "./item-style";

@media only screen and (max-device-width : 480px) {
    .included {
        align-self: flex-end;

        &__text {
            color: #141226;
            font-weight: bold;
            width: 100%;
        }
    }
}

</style>

<style lang="scss">
@import "~@s/_asset-mixers.scss";
@import "./multiselect-style";
</style>